/* eslint-disable react/no-danger */
/* eslint-disable react/prop-types */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import Image from 'gatsby-core-theme/src/hooks/gatsby-img';
import Breadcrumbs from 'gatsby-core-theme/src/components/atoms/breadcrumbs';
import {
  getSectionExtraField,
  imagePrettyUrl,
  translate,
} from 'gatsby-core-theme/src/helpers/getters';
import loadable from '@loadable/component';
import Module from 'gatsby-core-theme/src/components/molecules/module';
import keygen from 'gatsby-core-theme/src/helpers/keygen';
import { Context } from '~context/TranslationsProvider';
import SportButtons from '../../../../components/atoms/sport-buttons';
import styles from './header.module.scss';

const Header = ({ section }) => {
  const { translations } = useContext(Context) || {};
  const { header } = section?.page?.sections || {};
  const { relation, template } = section?.page || {};
  const isEventPage = template === 'event';
  const isHomePage = section?.page?.path === '/';
  const is404Page = template === '404';
  const noBackgroundImagePage =
    template === 'live_stream_providers' ||
    template === 'live_stream' ||
    template === 'provider_reviews' ||
    template === 'provider_review';

  const sport = section?.page?.relation?.sport?.name;

  const mobileBgImageField = getSectionExtraField(null, header, 'header_mobile_background_image');
  const desktopBgImage =
    getSectionExtraField(null, header, 'header_background_image') &&
    imagePrettyUrl(getSectionExtraField(null, header, 'header_background_image'));
  const mobileBgImage = mobileBgImageField ? imagePrettyUrl(mobileBgImageField) : null;

  let backgroundImg = (
    <div className={styles.bgImage}>
      <Image filename={`${sport || 'soccer'}-background`} alt={`${sport}background`} />
    </div>
  );

  const getImageFilename = () => {
    switch (sport) {
      case 'soccer':
        return 'soccer-event-desk';
      case 'handball':
        return 'handball-event';
      case 'tennis':
        return 'ground-image-tennis';
      default:
        return null;
    }
  };

  const fileName = getImageFilename();

  if (isEventPage) {
    backgroundImg = (
      <div className={styles.bgImage}>
        <Image filename={fileName} alt={`${sport}-eventbackground`} />
      </div>
    );
  } else if (noBackgroundImagePage) {
    backgroundImg = null;
  }

  if (desktopBgImage && mobileBgImage) {
    backgroundImg = (
      <picture className={styles.bgImage}>
        <source media="(min-width: 768px)" srcSet={desktopBgImage} />
        <source srcSet={mobileBgImage} />
        <img src={desktopBgImage} alt="header" height={450} width={1440} />
      </picture>
    );
  }

  const getBoxSection = () => {
    let BoxComponent = null;

    switch (section?.page?.template) {
      case 'sport':
        BoxComponent = loadable(() =>
          import('../../../../components/molecules/header/schedule-box')
        );
        return <BoxComponent section={section} category={sport} />;
      case 'event':
        BoxComponent = loadable(() => import('../../../../components/molecules/header/game-box'));
        return <BoxComponent section={section} category={sport} />;
      case 'live_stream_providers':
        BoxComponent = loadable(() =>
          import('../../../../components/molecules/header/provider-box')
        );
        return <BoxComponent section={section} category={sport} />;
      default:
        return null;
    }
  };

  return (
    <header
      className={`${styles.header} ${isHomePage && styles.home} ${is404Page && styles.errorPage} ${
        styles[section?.page?.template]
      } ${styles[sport]}`}
    >
      {backgroundImg && (
        <>
          {backgroundImg}
          <div className={styles.imageShadow} />
        </>
      )}
      <div className={styles.content}>
        <div className={styles.headerText}>
          {section?.page?.path && !isHomePage && (
            <div className={styles.breadcrumbs}>
              <Breadcrumbs page={section?.page} separator={<span>{' > '}</span>} />
            </div>
          )}
          {isEventPage ? (
            <h1>
              {`
              ${translate(translations, 'watch', 'Watch')} ${relation?.event?.home_team.name}`}
              <span> VS </span>
              {relation?.event?.away_team.name}
              <span>
                {` ${translate(translations, 'live_stream', 'live stream')} ${
                  relation?.sport?.path
                }`}
              </span>
            </h1>
          ) : (
            <div
              className={styles.headerTextInner}
              dangerouslySetInnerHTML={{
                __html: getSectionExtraField(null, header, 'header_content'),
              }}
            />
          )}
          {isHomePage && (
            <SportButtons sports={section?.page?.relation?.sports} gtmClass="header-gtm" />
          )}
        </div>
        {getBoxSection()}
      </div>
      <div className={styles.headerModules}>
        {header?.modules &&
          header.modules.map((module) => (
            <Module key={keygen()} module={module} page={section?.page} pageContext={section} />
          ))}
      </div>
    </header>
  );
};

export default Header;

Header.propTypes = {
  section: PropTypes.shape({
    page: PropTypes.shape({
      template: PropTypes.string,
      path: PropTypes.string,
      updated_at: PropTypes.string,
      created_at: PropTypes.string,
      relation: PropTypes.shape({}),
      author: PropTypes.shape({
        name: PropTypes.string,
        profile_page_path: PropTypes.string,
      }),
      sections: PropTypes.shape({
        header: PropTypes.shape({
          modules: PropTypes.shape({}),
          extra_fields: PropTypes.shape({
            header_background_image: PropTypes.oneOfType([
              PropTypes.string,
              PropTypes.shape({
                value: PropTypes.string,
                type: PropTypes.string,
              }),
            ]),
            header_content: PropTypes.oneOfType([
              PropTypes.string,
              PropTypes.shape({
                value: PropTypes.string,
                type: PropTypes.string,
              }),
            ]),
          }),
        }),
      }),
      title: PropTypes.string,
    }),
  }).isRequired,
};
